import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <section className="relative min-h-[700px] md:min-h-[800px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/assets/images/hero-bg-v2.jpg"
          alt="Veteriner Kliniği Arka Plan"
          className="w-full h-full object-cover"
          loading="eager"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-900/75 to-primary-800/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/40 via-transparent to-transparent" />
      </div>

      {/* Floating Elements */}
      <div className="absolute top-20 right-10 w-20 h-20 rounded-full bg-primary-500/10 blur-2xl animate-pulse" />
      <div className="absolute bottom-40 left-20 w-32 h-32 rounded-full bg-primary-400/10 blur-3xl animate-pulse" style={{ animationDelay: "1s" }} />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-24 md:py-32">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left Content */}
          <div
            className="text-white transition-all duration-1000"
            style={{
              opacity: loaded ? 1 : 0,
              transform: loaded ? "translateY(0)" : "translateY(40px)",
            }}
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500/20 backdrop-blur-sm rounded-full text-sm font-medium text-primary-200 mb-6 border border-primary-400/30">
              <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse" />
              Hizmet Alanımız
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-6">
              Kuş &{" "}
              <span className="font-serif italic text-primary-300">Egzotik</span>
              <br />
              Hayvan Hizmetleri
            </h1>

            <p className="text-lg md:text-xl text-white/80 leading-relaxed mb-8 max-w-xl">
              Ankara'da kuş ve egzotik hayvanlar konusunda en kapsamlı hizmeti sunuyoruz.
              Kafes kuşlarının hastalık teşhis ve tedavileri ile egzotik türler için özel
              bakım ve tedavi programları hazırlıyoruz.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Link
                to="/kus-egzotik"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-xl transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-xl hover:-translate-y-0.5"
              >
                Kuş Bakımı Hizmetlerimiz
                <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center" />
              </Link>
              <Link
                to="/iletisim"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-xl border border-white/20 transition-all duration-300 whitespace-nowrap backdrop-blur-sm"
              >
                <i className="ri-calendar-line w-5 h-5 flex items-center justify-center" />
                Randevu Al
              </Link>
            </div>

            {/* Instagram Accounts - Prominent */}
            <div className="flex flex-wrap items-center gap-4">
              <p className="text-sm text-white/60">Bizi takip edin:</p>
              <a
                href="https://instagram.com/ihsan_ozer_veteriner_klinigi"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-purple-600/30 via-pink-500/30 to-orange-400/30 hover:from-purple-600/50 hover:via-pink-500/50 hover:to-orange-400/50 rounded-full text-sm text-white transition-all duration-300 border border-white/10 backdrop-blur-sm"
              >
                <i className="ri-instagram-line w-4 h-4 flex items-center justify-center text-pink-300" />
                @ihsan_ozer_veteriner_klinigi
              </a>
              <a
                href="https://instagram.com/ankarakusveterineri"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-purple-600/30 via-pink-500/30 to-orange-400/30 hover:from-purple-600/50 hover:via-pink-500/50 hover:to-orange-400/50 rounded-full text-sm text-white transition-all duration-300 border border-white/10 backdrop-blur-sm"
              >
                <i className="ri-instagram-line w-4 h-4 flex items-center justify-center text-pink-300" />
                @ankarakusveterineri
              </a>
            </div>
          </div>

          {/* Right Image Area */}
          <div
            className="hidden lg:block relative transition-all duration-1000 delay-300"
            style={{
              opacity: loaded ? 1 : 0,
              transform: loaded ? "translateY(0)" : "translateY(40px)",
            }}
          >
            <div className="relative">
              {/* Main Image */}
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="/assets/images/hero-parrot-v2.jpg"
                  alt="Papağan"
                  className="w-full object-cover aspect-[4/5]"
                  loading="eager"
                  fetchPriority="high"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/30 via-transparent to-transparent" />
              </div>

              {/* Experience Badge */}
              <div
                className="absolute -top-5 -right-5 bg-white rounded-2xl px-5 py-4 shadow-xl transition-all duration-700 delay-700"
                style={{
                  opacity: loaded ? 1 : 0,
                  transform: loaded ? "scale(1)" : "scale(0.8)",
                }}
              >
                <p className="text-3xl font-bold text-primary-700">2020</p>
                <p className="text-xs text-gray-600 font-medium">Kuruluş Yılı</p>
              </div>

              {/* Small Card - Iguana */}
              <div
                className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-4 shadow-xl flex items-center gap-4 transition-all duration-700 delay-900"
                style={{
                  opacity: loaded ? 1 : 0,
                  transform: loaded ? "translateX(0)" : "translateX(-20px)",
                }}
              >
                <img
                  src="/assets/images/hero-iguana-v2.jpg"
                  alt="İguana"
                  className="w-14 h-14 rounded-xl object-cover"
                />
                <div>
                  <p className="text-sm font-bold text-gray-900">Egzotik</p>
                  <p className="text-xs text-gray-500">Veteriner Hekim</p>
                </div>
              </div>

              {/* Stats Card */}
              <div
                className="absolute bottom-20 -right-8 bg-primary-600 rounded-2xl p-4 shadow-xl transition-all duration-700 delay-1100"
                style={{
                  opacity: loaded ? 1 : 0,
                  transform: loaded ? "translateX(0)" : "translateX(20px)",
                }}
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
                    <i className="ri-heart-fill w-5 h-5 flex items-center justify-center text-white" />
                  </div>
                  <div>
                    <p className="text-xl font-bold text-white">5000+</p>
                    <p className="text-xs text-primary-200">Mutlu Hasta</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2">
        <span className="text-xs text-white/50">Aşağı kaydır</span>
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 rounded-full bg-white/60 animate-bounce" />
        </div>
      </div>
    </section>
  );
}